import { de } from "date-fns/locale";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useOrganization } from "../../configurations/OrganizationContext";
import { isAadhaarMandatoryForOnboarding } from "../../configurations/aadhaarConfig";
import useDynamicFontFormatter from "../../shared/helper/useDynamicFontFormatter";
import { Alert, Autocomplete, Button, Checkbox, FormControl, FormLabel, Grid, IconButton, MenuItem, Select, Switch, TextField } from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import { format, parse } from "date-fns";
import { FormControlLabel, FormGroup, Radio, RadioGroup } from "@material-ui/core";
import { createFilter } from "react-select";
import { APPT_EVENING_TIMINGS, APPT_MORNING_TIMINGS } from "../../shared/constants";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import BtnCellRenderer from "../common/BtnCellRenderer";
import { useDispatch } from "react-redux";
import {
    ROOM,
    ROOM_STATUS_BOOKED,
    ROOM_STATUS_AVAILABLE,
    ROOM_CATEGORIES,
} from "../../shared/constants/index";
import doctorActions, {
    getDepartmentList,
} from "./../../core/actions/doctorActions";
import personDetailsService from "../../core/services/personDetailsService";
import { helperServices } from "../../shared/helper";
import { patientActions, tokenActions } from "../../core/actions";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
ORG_CODES
} from "../../shared/constants";

export default function PatientOneStepOnboard() {
    const gridRef = useRef();
    const org = useOrganization();
    const history = useHistory();
    const location = useLocation();
    const genderRefs = useRef([]);
    const returnTo = location.state?.returnTo;
    const formatText = useDynamicFontFormatter(org?.fontStyle);
    const [selectedGender, setSelectedGender] = useState("");
    const radioRefs = useRef([]);
    const [doctorList, setdoctorList] = useState([]);
    const [selectedDoctor, setselectedDoctor] = useState([]);
    const [timesoltList, setTimesoltList] = useState([]);
    const toggleSwitchRef = useRef(null);
    const checkinDateRef = useRef(null);
    const checkinTimeRef = useRef(null);
    const addPatientBtnRef = useRef(null);
    const [formErrors, setFormErrors] = useState({
        fname: "",
        phno: "",
        age: "",
        dob: "",
        adhar: "",
        email: "",
        city: "",
        state: "",
        emrPhono: "",
    });
    const [patientDetail, setPatientDetail] = useState({
        id: "",
        patientId: "",
        fname: "",
        mname: "",
        lname: "",
        age: "",
        adhar: "",
        phno: "",
        area: "",
        city: formatText(org?.address) || "Mangaluru",
        state: formatText(org?.state) || "Karnataka",
        pincode: "",
        gender: "",
        bloodgroup: "",
        occupation: "",
        address: "",
        dob: "",
        age: "",
        email: "",
        imgUrl: "",
        udt: "",
        visit: {
            reference: {
                refkey: "",
                refby: "",
            },
            referenceId: "",
            visitflag: "",
        },
        upload: {},
        type: "OutPatient",
        insurance: "",
        fileNo: "",
        srcRef: "",
        language: "",
        education: "",
        sociostatus: "",
        tokenNumber: "",
        deskNo: "",
        comments: "",
        status: "",
        ehrid: "",
        erpCustId: "",
        altPhno: "",
        emrPhono: "",
        iStatus: "",
        custGroupId: "G",
        custGrpDesc: "General Customer",
        mothern: "",
        fathern: "",
        fathernorspouse: "",
        checkAdharUpdate: "NO",
        maskAdhar: "",
        department: "",
    });
    const noFormatFields = [
        "department",
        "email",
        "type",
        "insurance",
        "bloodgroup",
        "custGroupId",
        "custGrpDesc",
        "gender",
    ];
    const [doctorCalender, setDoctorCalender] = useState({});
    const [leaveSolts, setLeaveSolts] = useState([]);
    const [filteredTimeSlot, setfilteredTimeSlot] = useState({});
    const [bookedCountAtTime, setBookedCountAtTime] = useState({});
    const [customerGroup, setCustomerGroup] = useState([]);
    const [department, setDepartment] = useState([]);
    const [docList, setDocList] = useState([]);
    const [callType, setCallType] = useState("Add");
    const todayDate = new Date().toISOString().split("T")[0];
    const todayDate1 = format(new Date(), "yyyy-MM-dd");
    const currentTime = format(new Date(), "HH:mm");
    const [appointmentDate, setAppointmentDate] = useState(todayDate1);
    const [appointmentTime, setAppointmentTime] = useState("");
    const [selecteddate, setSelecteddate] = useState(todayDate1);
    const [selectedTime, setSelectedTime] = useState(currentTime);
    const [appointmentDetail, setAppointmentDetail] = useState({
        patientId: "",
        visitId: "",
        vaId: "",
        counselor: "",
        gvid: "",
        apptdate: todayDate1,
        appthours: "",
        apptminutes: "",
        type: "Doctor",
        timeslots: [],
        c: {},
        v: {},
        va: {},
        departmentId: "",
    });
    const [showEmergency, setShowEmergency] = useState(false);
    const [pagination, setPagination] = useState(true);
    const [paginationPageSize, setPaginationPageSize] = useState(10);
    const [roomData, setRoomData] = useState([]);
    const [assignedRoom, setAssignedRoom] = useState();
    const context = { componentParent: (props) => handleRendererCall(props) };
    const [columnDefs] = useState([
        {
            headerName: "Id",
            field: "id",
            sortable: true,
            filter: true,
            flex: 0.5,
            resizable: true,
            floatingFilter: true,
        },
        {
            headerName: "Room Name",
            field: "roomName",
            sortable: true,
            filter: true,
            flex: 1,
            resizable: true,
            floatingFilter: true,
            onGridReady: "open",
        },
        {
            headerName: "Floor Id",
            field: "floorId",
            sortable: true,
            filter: true,
            flex: 0.5,
            resizable: true,
            floatingFilter: true,
        },
        {
            headerName: "Description",
            field: "description",
            sortable: true,
            filter: true,
            flex: 1,
            resizable: true,
            floatingFilter: true,
        },
        {
            headerName: "Status",
            field: "status",
            sortable: true,
            filter: true,
            flex: 0.75,
            resizable: true,
            floatingFilter: true,
        },
        {
            headerName: "Type",
            field: "type",
            sortable: true,
            filter: true,
            flex: 1,
            resizable: true,
            floatingFilter: true,
        },
        {
            headerName: "Actions",
            field: "Actions",
            sortable: true,
            filter: true,
            flex: 0.5,
            resizable: true,
            width: 150,
            headerCheckboxSelection: false,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
        },
    ]);
    const [isAssigning, setIsAssigning] = useState(false);
    const [roomSelected, selectedRoom] = useState(null);
    const dispatch = useDispatch();
    const [ServerRes, setServerRes] = useState({ success: "", error: "" });
    const [currentSelectedRoomId, setSelectedRoomId] = useState(null);
    const [patient, setPatient] = useState(null);
    const [reloadRoomData, setReloadRoomData] = useState(false);
    const [visitId, setVisitId] = useState(null);
    const [checkinDate, setCheckinDate] = useState(todayDate1);
    const [checkinTime, setCheckinTime] = useState(currentTime);


    useEffect(() => {
        if (assignedRoom?.roomStatus?.checkinDate) {
            const checkin = new Date(assignedRoom.roomStatus.checkinDate);
            setCheckinDate(checkin.toISOString().split("T")[0]);
            setCheckinTime(checkin.toTimeString().slice(0, 5));
        } else {
            const { date, time } = getCurrentDateTime();
            setCheckinDate(date);
            setCheckinTime(time);
        }
    }, [assignedRoom]);

    useEffect(() => {
        let list = [...APPT_MORNING_TIMINGS, ...APPT_EVENING_TIMINGS];
        setTimesoltList(list);
        getCustomerGroupInfo();
        getDepartmentList();
        getDoctorList();
    }, []);

    const handleInputChange = (name, value) => {
        let pDetail = { ...patientDetail };
        if (name === "type" && value === "Other" && org?.orgCode === ORG_CODES.MNH) {
            setFormErrors({
                fname: "",
                phno: "",
                age: "",
                dob: "",
                adhar: "",
                email: "",
                city: "",
                state: "",
                emrPhono: "",
                gender: "",
            });
            pDetail.visit.visitflag = "Other";
        } else {
            pDetail.visit.visitflag = null;
        }
        formErrors[name] = "";
        if (
            name === "type" &&
            !isAadhaarMandatoryForOnboarding(org, value)
        ) {
            formErrors.adhar = "";
        }
        console.log("In handleInputChange", name, value);

        if (name === "adhar") {
            pDetail.checkAdharUpdate = "YES";
        }

        // AGE validation
        if (name === "age") {
            if (/^(\d+(\.\d*)?|\.\d*)?$/.test(value)) {
                let correctedValue = value;
                if (value === ".") correctedValue = "0";
                else if (/^\.\d+$/.test(value)) correctedValue = "0" + value;
                else if (/^\d+\.$/.test(value)) correctedValue = value.slice(0, -1);

                pDetail[name] = correctedValue;
            }
        }

        // PHONE validation
        else if (name === "phno") {
            if ((Number(value) >= 0 || value === "") && value.length <= 10) {
                pDetail[name] = value;
            }
        }

        // EMAIL always raw (no formatting)
        else if (name === "email") {
            pDetail[name] = value;
        }

        // DOB validation
        else if (name === "dob") {
            if (value <= todayDate) {
                pDetail[name] = value;
                calculateAge(value, pDetail);
            }
        }

        // Reference field logic
        else if (name === "reference") {
            if (typeof value === "object" && value !== null) {
                pDetail.visit.referenceId = value.id;
                pDetail.visit.reference.refby = value.label;
                pDetail.visit.reference.refkey = "";
            } else {
                pDetail.visit.referenceId = null;
                pDetail.visit.reference.refby = value;
                pDetail.visit.reference.refkey = "";
            }
        }

        // Name validations
        else if (
            [
                "fname",
                "mname",
                "lname",
                "fathern",
                "mothern",
                "fathernorspouse",
            ].includes(name)
        ) {
            const nameRegex = ["fname", "mname", "lname"].includes(name)
                ? /^[A-Za-z ]*$/
                : /^[A-Za-z0-9/ ]*$/;

            if (value === "" || nameRegex.test(value)) {
                // Format name fields always
                pDetail[name] = formatText(value);
            }
        }

        // General case — formatting based on skip rule
        else {
            pDetail[name] = noFormatFields.includes(name) ? value : formatText(value);
        }

        setPatientDetail(pDetail);
        console.log("Updated pDetail:", pDetail);
    };


    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toISOString().split("T")[0]; // yyyy-mm-dd
        const time = now.toTimeString().slice(0, 5); // HH:mm
        return { date, time };
    };

    const getAgeFromDOB = (dob) => {
        if (!dob) return null;

        const birthDate = new Date(dob);
        if (isNaN(birthDate.getTime())) {
            console.warn("Invalid date provided:", dob);
            return null;
        }
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        const dayDiff = today.getDate() - birthDate.getDate();

        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }

        return age;
    };

    const calculateAge = (dob, pDetail) => {
        const age = getAgeFromDOB(dob);
        if (age !== null) {
            pDetail.age = age.toString();
        }
    };

    const handleKeyDown = (e) => {
        const invalidKeys = ["e", "E", "+", "-", "."];
        if (invalidKeys.includes(e.key)) {
            e.preventDefault();
        }
    };

    function removeCommaFromValues(obj) {
        const newObj = {};
        const newObj1 = {};

        for (let key in obj) {
            let ids = "";
            if (obj.hasOwnProperty(key)) {
                let data = obj[key].split(",");
                for (let index = 0; index < data.length; index++) {
                    if (data[index] != "") {
                        if (index != data.length - 1 && data[index + 1] != "") {
                            ids = ids + data[index] + ",";
                        } else {
                            ids = ids + data[index];
                        }
                    }
                }
                newObj[key] = ids;
            }
        }

        for (let key in newObj) {
            if (newObj[key] != "") {
                newObj1[key] = newObj[key];
            }
        }

        return newObj1;
    }


    const getdoctorCalender = (gvid, apptdate, patientId) => {
        if (!gvid || !apptdate) {
            return;
        }

        const calData = {
            apptdate: apptdate,
            gvid: gvid
        };

        console.log("Fetching doctor calendar:", calData);

        dispatch(
            patientActions.getDoctorCalenderByDate(calData, (resCb) => {
                if (resCb && resCb.c) {
                    console.log("Doctor calendar response:", resCb);

                    const filteredTimeSlot = { ...resCb.c };
                    const keysToRemove = ["id", "gvid", "date"];
                    keysToRemove.forEach((key) => delete filteredTimeSlot[key]);

                    const updatedData = removeCommaFromValues(filteredTimeSlot);
                    console.log("Cleaned calendar data:", updatedData);

                    setfilteredTimeSlot(updatedData);

                    let bookedCountAtTimeloc = {};
                    if (updatedData != null) {
                        Object.entries(updatedData).map(([key, value]) => {
                            if (
                                updatedData[key] != null &&
                                updatedData[key] != "" &&
                                key != "gvid" &&
                                key != "id" &&
                                key != "date"
                            ) {
                                bookedCountAtTimeloc[key] = value.split(",").length;
                                bookedCountAtTimeloc["pateintId"] = value.split(",");
                            }
                        });
                    }
                    setBookedCountAtTime(bookedCountAtTimeloc);

                    let timeslotsFromDb = [];
                    if (updatedData != null) {
                        Object.keys(updatedData).forEach((key) => {
                            if (
                                updatedData[key] != null &&
                                updatedData[key] != "" &&
                                key != "gvid" &&
                                key != "id"
                            ) {
                                timeslotsFromDb.push(key);
                            }
                        });
                    }
                    setDoctorCalender(timeslotsFromDb);

                    console.log("Doctor calendar loaded successfully");
                }
            })
        );
        getleaveCalender(gvid, apptdate);
    };

    const getleaveCalender = (gvid, date) => {
        if (!gvid || !date) return;

        dispatch(
            patientActions.getleaveCalender(gvid, date, (resCb) => {
                if (resCb.successMessages) {
                    console.log("Leave calendar response:", resCb);
                    let check = "NA";
                    let slot = [];

                    if (resCb.lc != null) {
                        Object.entries(resCb.lc).forEach(([key, value]) => {
                            if (value === check) {
                                slot.push(key);
                            }
                        });
                    }
                    setLeaveSolts(slot);
                    console.log("Leave slots:", slot);
                }
            })
        );
    };

    const handleOnChange = (type, event) => {
        if (type === "date") {
            const selectedDate = event.target.value;
            setSelecteddate(selectedDate);
            setAppointmentDate(selectedDate);
            if (patientDetail.type === "InPatient") {
                setCheckinDate(selectedDate);
            }
        }

        if (type === "time") {
            const selectedTime = event.target.value;
            setSelectedTime(selectedTime);
            const nearestSlot = findNearestTimeslot(selectedTime, timesoltList);
            setAppointmentTime(nearestSlot);
            if (patientDetail.type === "InPatient") {
                setCheckinTime(selectedTime);
            }
        }
        if (type === "checkinDate") {
            setCheckinDate(event.target.value);
        }
        // if (type === "checkinTime") {
        //     setCheckinTime(event.target.value);
        // }
        if (type === "checkinTime") {
            setCheckinTime(event.target.value);
        }

    };


    const getCustomerGroupInfo = () => {
        dispatch(
            patientActions.getCustomerGroupInfo((resCb) => {
                if (resCb) {
                    setCustomerGroup(resCb?.customerGroupInfo);
                }
            })
        );
    };


    const getDoctorList = () => {
        const resCb = personDetailsService.getDoctorsDetail();
        if (resCb) {
            const list = resCb
                .filter(Boolean)
                .map(doc => helperServices.buildDoctorOption(doc));

            setDocList(list);
            console.log("Doctor List Rajani :", list);
        }
    };

    const getDepartmentList = (data) => {
        dispatch(
            doctorActions.getDepartmentList(data, (resCb) => {
                if (resCb) {
                    let deptlist = [];
                    for (let dept of resCb) {
                        let deptopt = {};
                        deptopt["id"] = dept.id;
                        deptopt["name"] = dept.name;
                        deptlist.push(deptopt);
                    }
                    setDepartment([...deptlist]);
                }
            })
        );
    };

    const handleCheckbox = (e) => {
        console.log("value:", e.target);
        let pDetail = patientDetail;
        pDetail.insurance = pDetail.insurance == "YES" ? "NO" : "YES";
        console.log("pDetail:", pDetail);
        setPatientDetail({ ...pDetail });
    };

    const handleDeptChange = (event) => {
        console.log("handleDeptChange event:", event);

        if (event && event.gvid) {
            setselectedDoctor(event.label);
            setAppointmentDetail(prev => ({
                ...prev,
                counselor: event.gvid,
                gvid: event.gvid,
                departmentId: event.departmentId || ""
            }));
            setPatientDetail(prev => ({
                ...prev,
                visit: {
                    ...prev.visit,
                    gvid: event.gvid,
                    doctorName: event.label
                }
            }));
            const dateToCheck = appointmentDate || todayDate1;
            console.log("Loading calendar for doctor:", event.gvid, "on date:", dateToCheck);
            getdoctorCalender(event.gvid, dateToCheck, null);

            console.log("Selected doctor:", event);
        } else {
            setselectedDoctor("");
            setAppointmentDetail(prev => ({
                ...prev,
                counselor: "",
                gvid: "",
                departmentId: ""
            }));
            setPatientDetail(prev => ({
                ...prev,
                visit: {
                    ...prev.visit,
                    gvid: "",
                    doctorName: ""
                }
            }));
            setfilteredTimeSlot({});
            setBookedCountAtTime({});
            setDoctorCalender({});
            setLeaveSolts([]);
        }
    };

    const parseAppointmentTime = (timeString) => {
        if (!timeString) return { hours: "", minutes: "" };

        const [hours, minutes] = timeString.split(':');
        return {
            hours: hours,
            minutes: minutes
        };
    };


    const assignDoctorAppointment = (patientResponse) => {
        if (!selectedDoctor || !patientResponse) {
            return;
        }

        const visit = patientResponse.visit;
        const visitAssignment = patientResponse?.visit?.visitAssignment;
        const { hours, minutes } = parseAppointmentTime(appointmentTime);
        const timeslots = [];
        const calendarObj = {};

        if (appointmentTime && hours && minutes) {
            const slotType = findTimeSlotType(appointmentTime);
            if (slotType) {
                timeslots.push(slotType);
                calendarObj[slotType] = patientResponse.id;
            }
        }

        const appointmentData = {
            patientId: patientResponse.id,
            visitId: visit.id,
            vaId: visitAssignment?.id || "",
            counselor: appointmentDetail.gvid,
            gvid: appointmentDetail.gvid,
            apptdate: appointmentDate || todayDate1,
            appthours: hours || "",
            apptminutes: minutes || "",
            type: "Doctor",
            timeslots: timeslots,
            c: calendarObj,
            v: visit,
            va: visitAssignment || {
                id: null,
                visitid: visit.id,
                patientId: patientResponse.id,
                targetid: appointmentDetail.gvid,
                status: "open",
                type: "Doctor"
            },
            departmentId: appointmentDetail.departmentId
        };

        console.log("Assigning doctor with data:", appointmentData);

        dispatch(
            patientActions.addAppointment(appointmentData, "Doctor", (resCb) => {
                if (resCb?.successMessages) {
                    console.log("Doctor assigned successfully");
                    if (patientResponse.type === "OutPatient" && visit.status === "open") {
                        tokenChange(visit.id, appointmentDetail.gvid, "Doctor");
                    }

                    setServerRes({
                        success: "Patient added and doctor assigned successfully",
                        error: "",
                    });
                } else if (resCb?.errorMessages) {
                    setServerRes({
                        success: "Patient added but failed to assign doctor",
                        error: resCb.errorMessages[0],
                    });
                }
            })
        );
    };



    const findTimeSlotType = (timeString) => {
        for (let item of APPT_MORNING_TIMINGS) {
            if (item.time1 === timeString) return item.type1;
            if (item.time2 === timeString) return item.type2;
            if (item.time3 === timeString) return item.type3;
            if (item.time4 === timeString) return item.type4;
        }

        for (let item of APPT_EVENING_TIMINGS) {
            if (item.time1 === timeString) return item.type1;
            if (item.time2 === timeString) return item.type2;
            if (item.time3 === timeString) return item.type3;
            if (item.time4 === timeString) return item.type4;
        }

        return null;
    };



    const tokenChange = (visitId, gvId, type) => {
        console.log("Generating token for visit:", visitId, gvId);
        dispatch(
            tokenActions.tokenGenerate(visitId, gvId, (resCb) => {
                if (resCb) {
                    console.log("Token generated:", resCb.token);
                }
            })
        );
    };

    const handleRendererCall = () => {
    }

    const isRowSelectable = useMemo(() => {
        return (params) => {
            return (
                !!params.data &&
                params.data.roomStatus &&
                params.data.roomStatus.bookstatus != "closed"
            );
        };
    }, []);


    const onSelectionChanged = (e) => {
        if (e.api.getSelectedRows().length > 0) {
            const selectedRow = e.api.getSelectedRows()[0];
            selectedRoom({ ...selectedRow });
            console.log("Room selected:", selectedRow);
        } else {
            selectedRoom(null);
        }
    };


    const assignRoomToPatient = (visitId, roomData) => {
        if (!visitId || !roomData) {
            return Promise.resolve(false);
        }

        let data = { ...roomData };
        if (checkinDate && checkinTime) {
            const checkinDateTime = new Date(`${checkinDate}T${checkinTime}`);
            data.admissionDateTime = checkinDateTime.toISOString();
        }
        if (data.emergencystatus === true) {
            data.emergencyroomstatus = data.emergencyroomstatus || {};
            data.emergencyroomstatus.bookstatus = ROOM_STATUS_BOOKED;
        } else {
            data.roomStatus = data.roomStatus || {};
            data.roomStatus.bookstatus = ROOM_STATUS_BOOKED;
        }

        data.visitid = visitId;

        return new Promise((resolve) => {
            dispatch(
                doctorActions.assignRoom(data, (resCb) => {
                    if (resCb?.successMessages) {
                        console.log("Room assigned successfully");
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                })
            );
        });
    };

    const getRowStyle = (params) => {
        if (
            params.data.visitid === null &&
            params.data.roomStatus &&
            params.data.roomStatus.bookstatus == "booked"
        ) {
            return { background: "lightgray" };
        }
    };

    const getRowClass = (params) => {
        if (
            params.data.visitid === null &&
            params.data.roomStatus &&
            params.data.roomStatus.bookstatus == "booked"
        ) {
            return "disable-row";
        }
    };

    function onRowDataChanged(e) {
        console.log("params", e);
        gridRef.current.api.forEachNode((node) => {
            if (node.data.assignedroom) {
                console.log("params", e);
                node.setSelected(true);
            }
        });
    }


    const getRoomsList = () => {
        // One-step room assignment requests admission-room categories directly.
        // Room eligibility therefore comes from room categories, not patient type.
        const data = {
            facilityId: "",
            roomStatus: [],
            roomCategories: [
                ROOM_CATEGORIES.ADMISSION_ROOM,
            ],
        };
        dispatch(
            doctorActions.getRoomList(data, (resCb) => {
                if (resCb && resCb.roomList) {
                    let roomList = Object.values(resCb.roomList).map((item) => ({
                        ...item,
                        id: item.id,
                        roomName: item.roomName,
                        floorId: item.floorId,
                        status: item.roomStatus?.bookstatus || "available",
                        type: item.type,
                        description: item.description,
                        roomCategory: item.roomCategory,
                        linkedblockrooms: item?.linkedblockrooms || null,
                    }));

                    // Filter out blocked rooms
                    const bookedRooms = roomList.filter((r) => r.status === "booked");
                    const blockedIds = new Set();
                    bookedRooms.forEach((room) => {
                        const blockInfo = room?.linkedblockrooms?.blockedBy;
                        if (blockInfo) {
                            blockInfo.split(",")
                                .map((id) => Number(id.trim()))
                                .forEach((id) => blockedIds.add(id));
                        }
                    });

                    const availableRooms = roomList.filter((room) =>
                        room.status === "available" &&
                        !blockedIds.has(room.id)
                    );
                    setRoomData(availableRooms);
                }
            })
        );
    };

    const getAssignedRoom = (data, fullRoomList) => {
        if (!data || !data.visitId) {
            setAssignedRoom(null);
            return;
        }

        const patientData = { ...data, visitid: data.visitId };
        const bookedRooms = fullRoomList.filter((r) => r.status === "booked");
        const blockedIds = new Set();

        bookedRooms.forEach((room) => {
            const blockInfo = room?.linkedblockrooms?.blockedBy;
            if (!blockInfo) return;
            blockInfo
                .split(",")
                .map((id) => Number(id.trim()))
                .forEach((id) => blockedIds.add(id));
        });

        dispatch(
            doctorActions.getAssignedRoom(patientData, (resCb) => {
                if (resCb?.room?.id) {
                    const assignedRoom = { ...resCb.room };
                    const assignedStatus = assignedRoom.roomStatus?.bookstatus || "occupied";

                    setAssignedRoom(assignedRoom);

                    let updatedList = fullRoomList.map((item) => {
                        if (item.id === assignedRoom.id) {
                            return {
                                ...item,
                                visitid: assignedRoom.visitid || assignedRoom.visitId,
                                assignedroom: true,
                                status: assignedStatus,
                            };
                        }
                        return { ...item, assignedroom: false };
                    });

                    if (!updatedList.some((r) => r.id === assignedRoom.id)) {
                        updatedList.push({
                            ...assignedRoom,
                            assignedroom: true,
                            status: assignedStatus,
                            visitid: assignedRoom.visitid || assignedRoom.visitId,
                        });
                    }

                    updatedList = updatedList.filter(
                        (r) => r.status === "available" || r.id === assignedRoom.id
                    );

                    const assigned = updatedList.find((r) => r.id === assignedRoom.id);
                    if (assigned) {
                        updatedList = [
                            assigned,
                            ...updatedList.filter((r) => r.id !== assignedRoom.id),
                        ];
                    }

                    setRoomData([...updatedList]);
                    setReloadRoomData((prev) => !prev);
                    setSelectedRoomId(assignedRoom.id);
                } else {
                    let availableRooms = fullRoomList.filter(
                        (r) => r.status === "available" && !blockedIds.has(r.id)
                    );
                    setRoomData(availableRooms);
                    setAssignedRoom(null);
                    setReloadRoomData((prev) => !prev);
                }
            })
        );
    };

    const showEmergencyRooms = () => {
        let data = { facilityId: "", roomStatus: [] };
        dispatch(
            doctorActions.getEmergencyRoomList(data, (resCb) => {
                if (resCb && resCb.roomList) {
                    let roomList = Object.values(resCb.roomList).map((item) => ({
                        ...item,
                        id: item.id,
                        roomName: item.roomName,
                        floorId: item.floorId,
                        status: item.emergencyroomstatus?.bookstatus || "available",
                        type: item.type,
                        description: item.description,
                        roomStatus: item.emergencyroomstatus,
                        emergencystatus: true,
                    }));

                    const availableList = roomList.filter((r) => r.status === "available");
                    setRoomData(availableList);
                }
            })
        );
    };
    const getAssignedEmergencyRoom = (data, list) => {
        if (data && data.visitId) {
            let patientData = { ...data, visitid: data.visitId };

            dispatch(
                doctorActions.getAssignedEmergencyRoom(patientData, (resCb) => {
                    if (resCb && resCb.room && resCb.room.id) {
                        setAssignedRoom(resCb.room);

                        let updatedList = list.map((item) => {
                            if (item.id === resCb.room.id) {
                                setSelectedRoomId(item.id);
                                return {
                                    ...item,
                                    visitid: resCb.room.visitid,
                                    assignedroom: true,
                                    status: resCb.room.emergencyroomstatus?.bookstatus || "available",
                                };
                            }
                            return { ...item, assignedroom: false };
                        });

                        if (!updatedList.some((r) => r.id === resCb.room.id)) {
                            updatedList.push({
                                ...resCb.room,
                                assignedroom: true,
                                status: resCb.room.emergencyroomstatus?.bookstatus || "available",
                            });
                        }

                        updatedList = updatedList.filter(
                            (r) => r.status === "available" || r.id === resCb.room.id
                        );

                        const assignedRoom = updatedList.find((r) => r.id === resCb.room.id);
                        if (assignedRoom) {
                            updatedList = [
                                assignedRoom,
                                ...updatedList.filter((r) => r.id !== resCb.room.id),
                            ];
                        }

                        setRoomData([...updatedList]);
                        setReloadRoomData((prev) => !prev);
                    } else {
                        const availableList = list.filter((r) => r.status === "available");
                        setRoomData([...availableList]);
                        setReloadRoomData((prev) => !prev);
                        setAssignedRoom(null);
                    }
                })
            );
        }
    };

    const toggleRooms = () => {
        if (showEmergency) {
            getRoomsList();
        } else {
            showEmergencyRooms();
        }
        setShowEmergency(!showEmergency);
        selectedRoom(null);
    };

    const assignSelectedRoom = async () => {
        if (assignedRoom?.emergencystatus !== true && !roomSelected) {
            setServerRes({ success: "", error: "Please select a room" });
            setTimeout(() => closeAlert(), 3000);
            return;
        }

        setIsAssigning(true);
        try {
            if (!roomSelected && assignedRoom && assignedRoom.emergencystatus === true) {
                await roomCheckout(assignedRoom, "checkout");
                return;
            }

            if (roomSelected && roomSelected.id !== currentSelectedRoomId) {
                await roomCheckout(roomSelected);
                return;
            }

            if (roomSelected && roomSelected.id === currentSelectedRoomId) {
                setServerRes({ success: "Room already assigned", error: "" });
            }
        } catch (err) {
            console.error("Assignment error:", err);
            setServerRes({ success: "", error: "An unexpected error occurred" });
        } finally {
            setIsAssigning(false);
        }
    };

    const roomCheckout = (data, mode = "assign") => {
        if (!assignedRoom) {
            if (mode === "assign") {
                return assignRoom(data);
            }
            return Promise.resolve();
        }

        let room = { ...assignedRoom };
        const username = localStorage.getItem("name");

        if (room.emergencystatus === true) {
            room.emergencyroomstatus = room.emergencyroomstatus || {};
            room.emergencyroomstatus.uby = username;
            room.emergencyroomstatus.cby = username;
            room.emergencyroomstatus.bookstatus = ROOM_STATUS_AVAILABLE;
        } else {
            room.roomStatus = room.roomStatus || {};
            room.roomStatus.uby = username;
            room.roomStatus.cby = username;
            room.roomStatus.bookstatus = ROOM_STATUS_AVAILABLE;
        }
        room.visitid = visitId;

        return new Promise((resolve) => {
            dispatch(
                doctorActions.roomCheckout(room, async (resCb) => {
                    if (resCb && mode === "assign") {
                        await assignRoom(data);
                        resolve(resCb);
                    } else if (resCb && mode === "checkout") {
                        if (resCb.successMessages) {
                            setServerRes({ success: "Room checked out successfully", error: "" });
                        }
                        if (resCb.errorMessages) {
                            setServerRes({ success: "", error: "Failed to checkout room" });
                        }
                        getRoomsList();
                        resolve(resCb);
                    } else {
                        resolve(resCb);
                    }
                })
            );
        });
    };

    const assignRoom = (room) => {
        let data = { ...room };

        if (checkinDate && checkinTime) {
            const checkinDateTime = new Date(`${checkinDate}T${checkinTime}`);
            data.admissionDateTime = checkinDateTime.toISOString();
        }

        if (data.emergencystatus === true) {
            data.emergencyroomstatus.bookstatus = ROOM_STATUS_BOOKED;
        } else {
            data.roomStatus.bookstatus = ROOM_STATUS_BOOKED;
        }

        data.visitid = visitId;

        return new Promise((resolve) => {
            dispatch(
                doctorActions.assignRoom(data, (resCb) => {
                    if (resCb?.successMessages) {
                        setServerRes({ success: "Room booked successfully", error: "" });
                    }
                    if (resCb?.errorMessages) {
                        setServerRes({
                            success: "",
                            error: resCb.errorMessages?.[0] || "Failed to allocate room",
                        });
                    }
                    resolve(resCb);
                })
            );
        });
    };

    const closeAlert = () => {
        setServerRes({ success: "", error: "" });
    };


    useEffect(() => {
        if (patientDetail.type === "InPatient") {
            getRoomsList();
        }
    }, [patientDetail.type]);


    const roundTimeToNearest15Min = (timeString) => {
        if (!timeString) return "";
        const [hours, minutes] = timeString.split(':').map(Number);
        let totalMinutes = hours * 60 + minutes;
        const remainder = totalMinutes % 15;
        if (remainder !== 0) {
            totalMinutes += (15 - remainder);
        }
        const newHours = Math.floor(totalMinutes / 60) % 24;
        const newMinutes = totalMinutes % 60;
        return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
    };


    const findNearestTimeslot = (timeString, timeslotList) => {
        if (!timeString) return "";
        const roundedTime = roundTimeToNearest15Min(timeString);
        const allSlots = [];
        timeslotList.forEach(element => {
            [element.time1, element.time2, element.time3, element.time4].forEach(slot => {
                if (slot) allSlots.push(slot);
            });
        });
        const matchingSlot = allSlots.find(slot => slot === roundedTime);
        if (matchingSlot) return matchingSlot;
        const [targetHours, targetMinutes] = roundedTime.split(':').map(Number);
        const targetTotalMinutes = targetHours * 60 + targetMinutes;

        for (const slot of allSlots) {
            const [slotHours, slotMinutes] = slot.split(':').map(Number);
            const slotTotalMinutes = slotHours * 60 + slotMinutes;

            if (slotTotalMinutes >= targetTotalMinutes) {
                return slot;
            }
        }

        return allSlots[0] || roundedTime;
    };


    const validateField = (fieldName, value) => {
        let errors = { ...formErrors };

        switch (fieldName) {
            case "fname":
                errors.fname = value ? "" : "Please enter first name";
                break;

            case "phno":
                if (!value) errors.phno = "Please enter phone number";
                else if (value.length !== 10)
                    errors.phno = "Please enter valid phone number";
                else errors.phno = "";
                break;

            case "age":
                errors.age = value ? "" : "Please enter age";
                break;

            case "gender":
                errors.gender = value ? "" : "Please select gender";
                break;

            case "city":
                errors.city = value ? "" : "Please enter city";
                break;

            case "state":
                errors.state = value ? "" : "Please enter state";
                break;

            case "adhar":
                if (!value) {
                    errors.adhar = isAadhaarMandatoryForOnboarding(
                        org,
                        patientDetail.type
                    )
                        ? "Aadhaar number is required"
                        : "";
                } else if (!/^\d{12}$/.test(value)) {
                    errors.adhar = "Please enter a valid 12-digit Aadhaar number";
                } else {
                    errors.adhar = "";
                }
                break;

            default:
                break;
        }

        setFormErrors(errors);
    };



    const validateForm = () => {
        let errors = {};
        const isMNH = org?.orgCode === ORG_CODES.MNH;
        const type = patientDetail.type || "OutPatient";
        if (isMNH && type === "Other") {
            if (!patientDetail.fname?.trim()) {
                errors.fname = "Please enter first name";
            }
            setFormErrors({
                fname: errors.fname || "",
                phno: "",
                age: "",
                gender: "",
                dob: "",
                email: "",
                emrPhono: "",
                adhar: "",
            });

            return Object.keys(errors).length === 0;
        }

        if (isMNH) {
            if (!patientDetail.fname?.trim()) {
                errors.fname = "Please enter first name";
            }

            if (!patientDetail.phno) {
                errors.phno = "Please enter phone number";
            } else if (patientDetail.phno.length !== 10) {
                errors.phno = "Please enter valid phone number";
            }

            if (!patientDetail.age) {
                errors.age = "Please enter age";
            }

            if (!patientDetail.gender) {
                errors.gender = "Please select gender";
            }

            if (!patientDetail.city?.trim()) {
                errors.city = "Please enter city";
            }

            if (!patientDetail.state?.trim()) {
                errors.state = "Please enter state";
            }

        }

        const isAadhaarMandatory = isAadhaarMandatoryForOnboarding(org, type);
        if (!patientDetail.adhar) {
            if (isAadhaarMandatory) {
                errors.adhar = "Aadhaar number is required";
            }
        } else if (!/^\d{12}$/.test(patientDetail.adhar)) {
            errors.adhar = "Please enter a valid 12-digit Aadhaar number";
        }

        setFormErrors({
            fname: errors.fname || "",
            phno: errors.phno || "",
            age: errors.age || "",
            gender: errors.gender || "",
            adhar: errors.adhar || "",
            dob: "",
            email: "",
            emrPhono: "",
        });

        return Object.keys(errors).length === 0;
    };




    const handleAddPatient = () => {
        const isValid = validateForm();
        if (!isValid) return;
        if (!patientDetail.type) {
            patientDetail.type = "OutPatient";
        }
        if (patientDetail.type === "Other" && org?.orgCode === ORG_CODES.MNH) {
            patientDetail.type = "OutPatient";
            patientDetail.visit.visitflag = "Other";
        } else {
            patientDetail.visit.visitflag = null;
        }
        let admissionDateTime = "";
        if (patientDetail.type === "InPatient") {
            admissionDateTime = `${selecteddate} ${selectedTime}:00`;
            console.log("[onboard UI] admissionDate/time selected:", { selecteddate, selectedTime, admissionDateTime });
        }

        dispatch(
            patientActions.addPatient(
                patientDetail,
                "preReg",
                admissionDateTime,
                async (resCb) => {
                    if (resCb?.successMessages) {
                        const patientResponse = resCb.patientresp;
                        const visit = patientResponse?.visit;
                        const patientId = visit?.patientId;
                        const visitId = visit?.id;
                        const erpCustId = patientResponse?.erpCustId;

                        dispatch(
                            patientActions.registrationFees(
                                erpCustId, 0, visitId, patientId, "MNH", [],
                                async () => {
                                    let doctorAssigned = false;
                                    let roomAssigned = false;

                                    // Assign doctor if selected
                                    if (selectedDoctor && appointmentDetail.gvid) {
                                        doctorAssigned = await assignDoctorAppointment(patientResponse);
                                    }

                                    //  Assign room if InPatient and room selected
                                    if (patientDetail.type === "InPatient" && roomSelected) {
                                        roomAssigned = await assignRoomToPatient(visitId, roomSelected);
                                    }

                                    // Build success message
                                    let successMsg = "Patient added successfully";
                                    if (doctorAssigned) successMsg += " and doctor assigned";
                                    if (roomAssigned) successMsg += " and room assigned";
                                    if (returnTo === "DoctorHomeView") {
                                        // Return to DoctorHomeView instead of PatientSections
                                        history.push({
                                            pathname: "/patient", // or whatever your DoctorHomeView route is
                                        });
                                    } else {
                                        // Default behavior - go to PatientSections
                                        history.push({
                                            pathname: `/PatientSections/${patientId}/${visitId}`,
                                        });
                                    }


                                    setServerRes({ success: successMsg, error: "" });
                                }
                            )
                        );
                    }
                }
            )
        );
    };

    const handleBack = () => {
        history.push("/patient");
    };

    // const handleRadioKeyDown = (e, index, value, field, refs) => {
    //     switch (e.key) {
    //         case "Enter":
    //         case " ":
    //             e.preventDefault();
    //             handleInputChange(field, value);
    //             break;

    //         case "ArrowRight":
    //         case "ArrowDown":
    //             e.preventDefault();
    //             refs.current[index + 1]?.focus();
    //             break;

    //         case "ArrowLeft":
    //         case "ArrowUp":
    //             e.preventDefault();
    //             refs.current[index - 1]?.focus();
    //             break;

    //         default:
    //             break;
    //     }
    // };

    const handleRadioKeyDown = (e, index, value, field, refs) => {
        // ENTER / SPACE → select
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleInputChange(field, value);
            return;
        }

        // TAB → move to next/prev radio
        if (e.key === "Tab") {
            // If NOT last radio → stay inside group
            if (!e.shiftKey && refs.current[index + 1]) {
                e.preventDefault();
                refs.current[index + 1].focus();
                return;
            }

            // Shift+Tab → go backward
            if (e.shiftKey && refs.current[index - 1]) {
                e.preventDefault();
                refs.current[index - 1].focus();
                return;
            }

            // If last radio → allow normal tab (go to next field)
            return;
        }

        // Arrow navigation (accessibility)
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
            e.preventDefault();
            refs.current[index + 1]?.focus();
        }

        if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
            e.preventDefault();
            refs.current[index - 1]?.focus();
        }
    };


    const isCheckinEarlierThanAdmission = () => {
        const admissionDateTime = new Date(`${selecteddate}T${selectedTime}`);
        const checkinDateTime = new Date(`${checkinDate}T${checkinTime}`);
        return checkinDateTime < admissionDateTime;
    };

    const handleToggleKeyDown = (e) => {
        if (e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            checkinDateRef.current?.focus();
        }
    };

    const handleCheckinDateKeyDown = (e) => {
        if (e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            checkinTimeRef.current?.focus();
        }
    };

    const handleCheckinTimeKeyDown = (e) => {
        if (e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();
            addPatientBtnRef.current?.focus();
        }
    };

    return (
        <main className="h-100 m-4">
            <div id="admin-appointment" className="ad-app appointment-modal ">
                {/* <h4 className="page-title mx-3">Patient OnBoard</h4> */}
                <div
                    className="d-flex align-items-center mx-3"
                    style={{ gap: "8px" }}
                >
                    {returnTo === "DoctorHomeView" && (
                        <IconButton
                            onClick={handleBack}
                            size="small"
                            aria-label="Back to patient list"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    )}

                    <h4 className="page-title m-0">Patient OnBoard</h4>
                </div>

                <div className="mx-3 mt-4" id="custGrp">
                    <Grid container className="mx-1 mt-4">
                        <Grid container alignItems="center" className="mb-3">
                            <Grid item className="field-gap">
                                <FormControl className="form-field">
                                    <Select
                                        name="customerGroup"
                                        value={patientDetail?.custGroupId ?? ""}
                                        onChange={(event) => {
                                            const selected = customerGroup?.find(
                                                (group) => group?.custGroupId === event.target.value
                                            );

                                            setPatientDetail((prev) => ({
                                                ...prev,
                                                custGroupId: selected?.custGroupId ?? null,
                                                custGrpDesc: selected?.description ?? "",
                                            }));
                                        }}
                                        disabled={!customerGroup || customerGroup.length === 0}
                                    >
                                        {customerGroup?.length > 0 ? (
                                            customerGroup.map((group) => (
                                                <MenuItem
                                                    key={group?.custGroupId}
                                                    value={group?.custGroupId}
                                                >
                                                    {group?.description ?? "N/A"}
                                                </MenuItem>
                                            ))
                                        ) : (
                                            <MenuItem disabled value="">
                                                No customer groups available
                                            </MenuItem>
                                        )}
                                    </Select>

                                </FormControl>
                            </Grid>
                            <Grid item className="field-gap">
                                <FormControl className="form-field">
                                    <Select
                                        name="category"
                                        value={patientDetail.type}
                                        disabled={callType === "Edit"}
                                        onChange={(event) => handleInputChange("type", event.target.value)}
                                    >
                                        <MenuItem value="InPatient">In Patient</MenuItem>
                                        <MenuItem value="OutPatient">Out Patient</MenuItem>
                                        {org?.isOnlinePatient?.display && (
                                            <MenuItem value="OnlinePatient">Online Patient</MenuItem>
                                        )}
                                        {org?.orgCode === ORG_CODES.MNH && <MenuItem value="Other">Other</MenuItem>}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {org?.orgCode === ORG_CODES.MNH && (
                                <Grid item className="field-gap">
                                    <FormControl className="form-field">
                                        <Select
                                            name="department"
                                            value={patientDetail.department || ""}
                                            onChange={(event) => handleInputChange("department", event.target.value)}
                                            displayEmpty
                                        >
                                            <MenuItem value="" disabled>Select Department</MenuItem>
                                            {department.map((dept) => (
                                                <MenuItem key={dept.id} value={dept.id}>
                                                    {dept.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}
                            <Grid item className="field-gap">
                                <FormControl className="form-field">
                                    <Autocomplete
                                        freeSolo
                                        options={docList.map((d) => ({ id: d.id, label: d.label }))}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.label
                                        }
                                        value={patientDetail.visit.reference.refby || ""}
                                        onChange={(e, value) => {
                                            if (typeof value === "string") handleInputChange("reference", value);
                                            else if (value?.id) handleInputChange("reference", value);
                                            else handleInputChange("reference", "");
                                        }}
                                        onInputChange={(e, value) => handleInputChange("reference", value)}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Reference" />
                                        )}
                                    />
                                </FormControl>
                            </Grid>

                        </Grid>
                        {patientDetail.type === "InPatient" && (
                            <Grid container alignItems="center" className="mb-3">
                                <Grid item className="field-gap">
                                    <TextField
                                        className="form-field"
                                        name="admissionDate"
                                        label="Admission Date"
                                        type="date"
                                        defaultValue={selecteddate}
                                        onChange={(event) => handleOnChange("date", event)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item className="field-gap">
                                    <TextField
                                        className="form-field"
                                        name="admissionTime"
                                        label="Admission Time"
                                        type="time"
                                        defaultValue={selectedTime}
                                        onChange={(event) => handleOnChange("time", event)}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                            </Grid>
                        )}
                        <Grid container alignItems="center" columns={5} className="mb-2" >
                            <Grid item xs={1}  >
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="First Name"
                                    required
                                    id="fname"
                                    value={patientDetail.fname}
                                    autoComplete="off"
                                    onChange={(e) => handleInputChange("fname", e.target.value)}
                                    sx={{
                                        "& .MuiFormLabel-asterisk": {
                                            color: "var(--bs-danger)",
                                        },
                                    }}
                                    error={formErrors.fname !== ""}
                                    helperText={
                                        <span style={{ color: "#EC4147" }}>
                                            {formErrors.fname}
                                        </span>
                                    }
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{ style: { height: "35px" } }}
                                />
                            </Grid>

                            <Grid item xs={1} >
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Middle Name"
                                    value={patientDetail.mname}
                                    onChange={(e) => handleInputChange("mname", e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={1} >
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Last Name"
                                    value={patientDetail.lname}
                                    onChange={(e) => handleInputChange("lname", e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={1} >
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Mother Name"
                                    id="mothern"
                                    autoComplete="off"
                                    value={patientDetail.mothern}
                                    onChange={(e) => handleInputChange("mothern", e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item xs={1} >
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Father Name"
                                    id="fathernorspouse"
                                    autoComplete="off"
                                    value={patientDetail.fathern}
                                    onChange={(e) => handleInputChange("fathern", e.target.value)}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" className="mb-2" columns={5}>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Spouse Name"
                                    id="fathernorspouse"
                                    value={patientDetail.fathernorspouse}
                                    placeholder="Spouse Name"
                                    autoComplete="off"
                                    onChange={(event) =>
                                        handleInputChange(
                                            "fathernorspouse",
                                            event.target.value
                                        )
                                    }

                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Phone Number"
                                    required
                                    id="phno"
                                    type="number"
                                    value={patientDetail.phno}
                                    // placeholder="Phone Number"
                                    autoComplete="off"
                                    onChange={(event) =>
                                        handleInputChange("phno", event.target.value)
                                    }
                                    sx={{
                                        "& .MuiFormLabel-asterisk": {
                                            color: "var(--bs-danger)",
                                        },
                                    }}
                                    onKeyDown={handleKeyDown}
                                    error={formErrors.phno !== ""}
                                    helperText={
                                        <span style={{ color: "#EC4147" }}>
                                            {formErrors.phno}
                                        </span>
                                    }
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Age"
                                    type="number"
                                    required
                                    id="age"
                                    min={0}
                                    value={patientDetail.age}
                                    placeholder="Age"
                                    autoComplete="off"
                                    onChange={(event) =>
                                        handleInputChange("age", event.target.value)
                                    }
                                    sx={{
                                        "& .MuiFormLabel-asterisk": {
                                            color: "var(--bs-danger)",
                                        },
                                    }}
                                    onKeyDown={handleKeyDown}
                                    error={formErrors.age !== ""}
                                    helperText={
                                        <span style={{ color: "#EC4147" }}>
                                            {formErrors.age}
                                        </span>
                                    }
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Aadhaar"
                                    required={isAadhaarMandatoryForOnboarding(
                                        org,
                                        patientDetail.type
                                    )}
                                    sx={{
                                        "& .MuiFormLabel-asterisk": {
                                            color: "var(--bs-danger)",
                                        },
                                    }}
                                    id="Adhar"
                                    type="number"
                                    inputProps={{
                                        min: "0",
                                        max: "999999999999",
                                    }}
                                    value={patientDetail.adhar}
                                    placeholder="000011112222"
                                    autoComplete="off"
                                    onChange={(event) => {
                                        handleInputChange("adhar", event.target.value);
                                    }}
                                    onKeyDown={handleKeyDown}
                                    error={formErrors.adhar !== ""}
                                    helperText={formErrors.adhar}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label
                                        style={{
                                            fontSize: "14px",
                                            marginBottom: "4px",
                                            color: "rgba(0,0,0,0.7)"
                                        }}
                                    >
                                        Gender <span className="text-danger">*</span>
                                    </label>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            height: "35px",
                                            border: formErrors.gender ? "1px solid #EC4147" : "none",
                                            padding: "0 8px",
                                            borderRadius: "4px"
                                        }}
                                    >
                                        {["Male", "Female", "Other"].map((g, index) => (
                                            <label
                                                key={g}
                                                style={{ display: "flex", alignItems: "center", gap: "3px" }}
                                            >
                                                <input
                                                    ref={(el) => (genderRefs.current[index] = el)}
                                                    type="radio"
                                                    name="gender"
                                                    value={g}
                                                    checked={patientDetail.gender === g}
                                                    tabIndex={0}                 // 🔥 critical
                                                    onChange={() => handleInputChange("gender", g)}
                                                    onKeyDown={(e) =>
                                                        handleRadioKeyDown(e, index, g, "gender", genderRefs)
                                                    }
                                                />
                                                {g}
                                            </label>
                                        ))}
                                    </div>

                                    {/* <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            height: "35px",
                                            border: formErrors.gender ? "1px solid #EC4147" : "none",
                                            padding: "0 8px",
                                            borderRadius: "4px"
                                        }}
                                    >
                                        <label style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                            <input
                                                type="radio"
                                                name="gender"
                                                value="Male"
                                                checked={patientDetail.gender === "Male"}
                                                onChange={(e) => handleInputChange("gender", e.target.value)}
                                            />
                                            Male
                                        </label>

                                        <label style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                            <input
                                                type="radio"
                                                name="gender"
                                                value="Female"
                                                checked={patientDetail.gender === "Female"}
                                                onChange={(e) => handleInputChange("gender", e.target.value)}
                                            />
                                            Female
                                        </label>

                                        <label style={{ display: "flex", alignItems: "center", gap: "3px" }}>
                                            <input
                                                type="radio"
                                                name="gender"
                                                value="Other"
                                                checked={patientDetail.gender === "Other"}
                                                onChange={(e) => handleInputChange("gender", e.target.value)}
                                            />
                                            Other
                                        </label>
                                    </div> */}

                                    {formErrors.gender && (
                                        <span style={{ color: "#EC4147", fontSize: "12px", marginTop: "4px" }}>
                                            {formErrors.gender}
                                        </span>
                                    )}
                                </div>
                            </Grid>

                        </Grid>
                        <Grid container alignItems="center" className="mb-2" columns={5}>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Alternate Phone Number"
                                    id="altNumber"
                                    value={patientDetail.altPhno}
                                    placeholder="Alternate phone number"
                                    autoComplete="off"
                                    onChange={(event) =>
                                        handleInputChange("altPhno", event.target.value)
                                    }
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    label="Date of Birth"
                                    className="pt-2 pb-2 form-field"
                                    type="date"
                                    id="birthdetails"
                                    value={patientDetail.dob}
                                    onChange={(event) =>
                                        handleInputChange("dob", event.target.value)
                                    }
                                    error={formErrors.dob !== ""}
                                    helperText={
                                        <span style={{ color: "#EC4147" }}>{formErrors.dob}</span>
                                    }
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true, // 🔥 keeps label always above the input
                                    }}
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                    inputProps={{
                                        max: todayDate,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Language"
                                    id="language"
                                    value={patientDetail.language}
                                    placeholder="Language"
                                    autoComplete="off"
                                    onChange={(event) =>
                                        handleInputChange("language", event.target.value)
                                    }
                                    variant="outlined"
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Education"
                                    id="education"
                                    value={patientDetail.education}
                                    placeholder="Education"
                                    autoComplete="off"
                                    onChange={(event) =>
                                        handleInputChange("education", event.target.value)
                                    }
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Socio Status"
                                    id="sociostatus"
                                    value={patientDetail.sociostatus}
                                    placeholder="Socio Status"
                                    autoComplete="off"
                                    onChange={(event) =>
                                        handleInputChange("sociostatus", event.target.value)
                                    }
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>

                        </Grid>
                        <Grid container alignItems="center" className="mb-2" >
                            <Grid item xs={11.7}>
                                <TextField
                                    className="pt-2 pb-2  "
                                    label="Address"
                                    id="feInputAddress"
                                    value={patientDetail.address}
                                    placeholder="1234 Main St"
                                    autoComplete="off"
                                    onChange={(e) =>
                                        handleInputChange("address", e.target.value)
                                    }
                                    fullWidth
                                    InputProps={{ style: { height: "35px" } }}
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" className="mb-2" columns={5}>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Emergency Phone Number"
                                    id="EmergencyPhno"
                                    type="number"
                                    value={patientDetail.emrPhono}
                                    placeholder="Emergency Phone Number"
                                    autoComplete="off"
                                    onChange={(event) => {
                                        handleInputChange("emrPhono", event.target.value);
                                    }}
                                    onKeyDown={handleKeyDown}
                                    error={formErrors.emrPhono !== ""}
                                    helperText={formErrors.emrPhono}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Source of Reference"
                                    id="srcRef"
                                    value={patientDetail.srcRef}
                                    placeholder="Source of Reference"
                                    autoComplete="off"
                                    onChange={(event) => {
                                        handleInputChange("srcRef", event.target.value);
                                    }}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Email Id"
                                    id="email"
                                    value={patientDetail.email}
                                    placeholder="Email Id"
                                    autoComplete="off"
                                    onChange={(event) => {
                                        handleInputChange("email", event.target.value);
                                    }}
                                    error={formErrors.email !== ""}
                                    helperText={formErrors.email}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Occupation"
                                    id="oc"
                                    value={patientDetail.occupation}
                                    placeholder="Occupation"
                                    autoComplete="off"
                                    onChange={(event) => {
                                        handleInputChange("occupation", event.target.value);
                                    }}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>

                                <FormControl fullWidth class="bloodGroup form-field">
                                    <Select
                                        displayEmpty
                                        labelId="bloodgroup-label"
                                        id="bloodgroup"
                                        value={patientDetail.bloodgroup}
                                        onChange={(event) => {
                                            handleInputChange(
                                                "bloodgroup",
                                                event.target.value
                                            );
                                        }}
                                    >
                                        <MenuItem value="">Blood Group</MenuItem>
                                        <MenuItem value="A +ve">A +ve</MenuItem>
                                        <MenuItem value="A -ve">A -ve</MenuItem>
                                        <MenuItem value="B +ve">B +ve</MenuItem>
                                        <MenuItem value="B -ve">B -ve</MenuItem>
                                        <MenuItem value="AB +ve">AB +ve</MenuItem>
                                        <MenuItem value="AB -ve">AB -ve</MenuItem>
                                        <MenuItem value="O +ve">O +ve</MenuItem>
                                        <MenuItem value="O-ve">O -ve</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" className="mb-2" columns={5}>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="City"
                                    id="feInputCity"
                                    placeholder="City"
                                    autoComplete="off"
                                    value={patientDetail.city}
                                    onChange={(event) => {
                                        handleInputChange("city", event.target.value);
                                    }}
                                    // error={formErrors.city !== ""}
                                    // helperText={formErrors.city}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="State"
                                    id="feInputState"
                                    placeholder="State"
                                    autoComplete="off"
                                    value={patientDetail.state}
                                    onChange={(event) => {
                                        handleInputChange("state", event.target.value);
                                    }}
                                    // error={formErrors.state !== ""}
                                    // helperText={formErrors.state}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <TextField
                                    className="pt-2 pb-2 form-field"
                                    label="Zip"
                                    id="feInputZip"
                                    placeholder="Zip"
                                    type="number"
                                    autoComplete="off"
                                    value={patientDetail.pincode}
                                    onChange={(event) => {
                                        handleInputChange("pincode", event.target.value);
                                    }}
                                    onKeyDown={handleKeyDown}
                                    fullWidth
                                    InputProps={{
                                        style: { height: "35px" },
                                    }}
                                />
                            </Grid>
                            <Grid item >
                                <FormControlLabel
                                    className="formControl"
                                    control={
                                        <Checkbox
                                            checked={patientDetail.insurance === "YES"}
                                            tabIndex={0}
                                            onChange={handleCheckbox}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    handleCheckbox(e);
                                                }
                                            }}
                                        />

                                    }
                                    label="Do you have insurance?"
                                />
                            </Grid>
                        </Grid>
                        <Grid container alignItems="center" className="row-space mt-2">
                            <Grid item xs={10}>
                                <h5 className="mb-3">Assign Doctor</h5>
                            </Grid>

                            <Grid item className="field-gap">
                                <FormControl className="form-field" fullWidth>
                                    <Autocomplete
                                        options={docList}
                                        size="small"
                                        value={docList.find((d) => d.label === selectedDoctor) || null}
                                        getOptionLabel={(option) => option?.label || ""}
                                        onChange={(event, value) => {
                                            // value is the full doctor option (or null when cleared)
                                            if (value) {
                                                handleDeptChange(value);
                                            } else {
                                                handleDeptChange(null);
                                            }
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Select Doctor"
                                                placeholder="Search doctor by name"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item className="field-gap">
                                <TextField
                                    label="Appointment Date"
                                    className="form-field"
                                    type="date"
                                    id="Apptdetails"
                                    value={appointmentDate}
                                    onChange={(event) => {
                                        const newDate = event.target.value;
                                        setAppointmentDate(newDate);
                                        if (appointmentDetail.gvid) {
                                            console.log("Reloading calendar for new date:", newDate);
                                            getdoctorCalender(appointmentDetail.gvid, newDate, null);
                                        }
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                //inputProps={{ min: selecteddate }}

                                />
                            </Grid>
                            <Grid item className="field-gap">
                                <div className="select-wrapper-marker form-field">
                                    <select
                                        className="select-tag-marker form-control"
                                        value={appointmentTime}
                                        onChange={(event) => {
                                            setAppointmentTime(event.target.value);
                                        }}
                                    >
                                        <option value="">Select Time</option>
                                        {timesoltList.map((element, idx) => {
                                            const types = [
                                                element.time1,
                                                element.time2,
                                                element.time3,
                                                element.time4,
                                            ];

                                            return types.map((type, index) => (
                                                <option key={`${idx}-${index}`} value={type}>
                                                    {element[`time${index + 1}`]}
                                                </option>
                                            ));
                                        })}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                        {patientDetail.type === "InPatient" && (
                            <Grid container alignItems="center" className="row-space mt-4">
                                <Grid item xs={12}>
                                    <h5 className="mb-3">Room Details</h5>

                                    <div className="mb-3">
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    inputRef={toggleSwitchRef}
                                                    checked={showEmergency}
                                                    tabIndex={0}
                                                    onChange={toggleRooms}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            toggleRooms();
                                                        }
                                                        handleToggleKeyDown(e);  // Add this
                                                    }}
                                                />

                                            }
                                            label={showEmergency ? "Show Normal Rooms" : "Show Emergency Rooms"}
                                        />
                                    </div>

                                    <div
                                        className="ag-theme-balham"
                                        style={{ height: "400px", width: "100%" }}
                                    >
                                        <AgGridReact
                                            key={showEmergency}
                                            ref={gridRef}
                                            pagination={pagination}
                                            paginationPageSize={paginationPageSize}
                                            rowData={roomData}
                                            columnDefs={columnDefs}
                                            rowSelection="single"
                                            suppressRowClickSelection={false}
                                            isRowSelectable={isRowSelectable}
                                            onSelectionChanged={onSelectionChanged}
                                            onRowDataChanged={onRowDataChanged}
                                            getRowClass={getRowClass}
                                            getRowStyle={getRowStyle}

                                        />
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end gap-3 mt-3">
                                        <span style={{ fontSize: "22px", marginRight: "12px" }}>
                                            Room Assigned at{" "}
                                        </span>

                                        <TextField
                                            inputRef={checkinDateRef}  // Add this
                                            className="form-field"
                                            name="checkinDate"
                                            label="Check-in Date"
                                            type="date"
                                            value={checkinDate}
                                            onChange={(event) => handleOnChange("checkinDate", event)}
                                            onKeyDown={handleCheckinDateKeyDown}  // Add this
                                            InputLabelProps={{ shrink: true }}
                                            size="small"
                                            // inputProps={{ min: selecteddate }}
                                            style={{ width: "200px" }}
                                        />

                                        <TextField
                                            inputRef={checkinTimeRef}
                                            className="form-field"
                                            name="checkinTime"
                                            label="Check-in Time"
                                            type="time"
                                            value={checkinTime}
                                            onChange={(event) => handleOnChange("checkinTime", event)}
                                            onKeyDown={handleCheckinTimeKeyDown}
                                            InputLabelProps={{ shrink: true }}
                                            size="small"
                                            style={{ width: "200px" }}
                                        />


                                    </div>
                                    {patientDetail.type === "InPatient" && isCheckinEarlierThanAdmission() && (
                                        <span style={{ color: "red", fontSize: "14px", marginTop: "4px", marginRight: "12px" }}>
                                            Warning: Check-in date/time is earlier than admission date/time.
                                        </span>
                                    )}
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    <div className="d-flex justify-content-end mt-3">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAddPatient}
                            ref={addPatientBtnRef}
                        >
                            Add Patient
                        </Button>
                    </div>
                </div>
            </div>
        </main>
    )
}
